import OverlayService from "./overlay-service.es6.js";

const DESKTOP_BREAKPOINT = 1023;

export default class GlobalSearchDropdown {
  constructor() {
    this.globalSearchDropdowns = document.querySelectorAll(
      '.global-search-dropdown',
    );
    this.searchButton = document
      .querySelector('.secondary-nav-and-search-button-wrapper')
      .querySelector('.search-button');
    this.desktopOverlay = document.querySelectorAll('.desktop-overlay');
    this.closeButtons = GlobalSearchDropdown.getChildElementsByClass(
      this.globalSearchDropdowns,
      '.close-button',
    );
    this.mobileMenuSearchBarWrapper = document.querySelector(
      '.mobile-menu-search-bar--wrapper',
    );
    this.mobileSearchBar = this.mobileMenuSearchBarWrapper.querySelector(
      '.mobile-menu-search-bar',
    );
    this.setListeners();

    this.overlayService = new OverlayService();
  }

  static getChildElementsByClass(parentElements, childElementClass) {
    const elements = [];
    parentElements.forEach(parentEl => {
      elements.push(parentEl.querySelector(childElementClass));
    });
    return elements;
  }

  static focusMobileSearchBar() {
    const indexOfMobileSearchBar = 1;
    document
      .querySelectorAll('.site-search-search-bar')
      [indexOfMobileSearchBar].focus();
  }

  openSearch() {
    this.globalSearchDropdowns.forEach(dropdown => {
      dropdown.classList.add('active');
    });
    if (window.innerWidth < DESKTOP_BREAKPOINT) {
      GlobalSearchDropdown.focusMobileSearchBar();
    }

    const onOverlayClick = () => {
      // Even though this is a one-liner, we need this in an anonymous function
      // to ensure "this" will refer to the correct object when passed to toggleOverlay
      this.closeSearch();
    };

    this.overlayService.toggleOverlay(true, onOverlayClick, true);
  }

  closeSearch() {
    this.globalSearchDropdowns.forEach(dropdown => {
      dropdown.classList.remove('active');
    });
    this.overlayService.toggleOverlay(false, undefined, true);
  }

  setClickListeners() {
    this.searchButton.addEventListener('click', () => {
      this.openSearch();
    });
    this.closeButtons.forEach(button => {
      button.addEventListener('click', () => {
        this.closeSearch();
      });
    });
    this.mobileSearchBar.addEventListener('click', () => {
      this.openSearch();
    });
  }

  setListeners() {
    window.addEventListener('load', () => {
      this.setClickListeners();
    });
  }
}

(() => {})(Drupal);
